export default __webpack_public_path__ + "static/media/bad_emoji.5ea73ff6.png";